import { Component } from '@angular/core';
import { Chart } from 'angular-highcharts';
import { ToastrService } from 'ngx-toastr';
import { Subject, takeUntil } from 'rxjs';
import { DEMO_VESSEL_PC } from 'src/app/shared/helpers/heating-table-dynamic-extract.util';
import { DashboardService } from 'src/app/shared/service/dashboard/dashboard.service';
import { RequestFormService } from 'src/app/shared/service/requestForm/request-form.service';

@Component({
  selector: 'app-tcp-graph',
  templateUrl: './tcp-graph.component.html',
  styleUrls: ['./tcp-graph.component.scss'],
})
export class TcpGraphComponent {
  chartOptions!: Chart;
  speedOptions = ['11', '11.5', '12', '12.5', '13', '13.5'];
  speedDropdownOpen = false;
  conditionOptions = ['Ballast', 'Laden'];
  clientOptions: any;
  segmentOptions: { label: string; value: string }[] = [];
  typeofshipOptions = [
    { label: 'Bulk carrier', value: 'Bulk carrier' },
    { label: 'Container ship', value: 'Container ship' },
    { label: 'General cargo', value: 'General cargo' },
    { label: 'Passenger ship', value: 'Passenger ship' },
    { label: 'Tanker', value: 'Tanker' },
    { label: 'Gas Tanker', value: 'Gas Tanker' },
  ];
  segmentMapping: { [key: string]: { label: string; value: string }[] } = {
    'Bulk carrier': [
      { label: 'Coaster', value: 'Coaster' },
      { label: 'Handysize', value: 'Handysize' },
      { label: 'Handymax', value: 'Handymax' },
      { label: 'Supramax', value: 'Supramax' },
      { label: 'Ultramax', value: 'Ultramax' },
      { label: 'Panamax', value: 'Panamax' },
      { label: 'Kamsarmax', value: 'Kamsarmax' },
      { label: 'Ultra Panamax', value: 'Ultrapanamax' },
      { label: 'Capesize', value: 'Capesize' },
      { label: 'Very Large Ore Carrier', value: 'VLOC' },
      { label: 'Chinamax', value: 'Chinamax' },
    ],
    Tanker: [
      { label: 'Coastal', value: 'Coastal' },
      { label: 'Intermediate', value: 'Intermediate' },
      { label: 'Handytankers', value: 'Handytankers' },
      { label: 'MR2', value: 'MR' },
      { label: 'LR1 / Panamax', value: 'LR1/Panamax' },
      { label: 'LR2 / Aframax', value: 'LR2/Aframax' },
      { label: 'LR3 / Suezmax', value: 'LR3/Suezmax' },
      { label: 'VLCC', value: 'VLCC' },
    ],
    'Gas Tanker': [
      { label: 'Coasters', value: 'Coasters' },
      { label: 'Handysize', value: 'Handysize' },
      { label: 'MGC', value: 'MGC' },
      { label: 'LGC', value: 'LGC' },
      { label: 'VLGC', value: 'VLGC' },
      { label: 'VLEC', value: 'VLEC' },
    ],
    'Container ship': [],
    'General cargo': [
      { label: 'Coaster', value: 'Coaster' },
      { label: 'Handysize', value: 'Handysize' },
      { label: 'Handymax', value: 'Handymax' },
      { label: 'Supramax', value: 'Supramax' },
      { label: 'Ultramax', value: 'Ultramax' },
      { label: 'Panamax', value: 'Panamax' },
      { label: 'Kamsarmax', value: 'Kamsarmax' },
      { label: 'Ultra Panamax', value: 'Ultrapanamax' },
      { label: 'Capesize', value: 'Capesize' },
      { label: 'Very Large Ore Carrier', value: 'VLOC' },
      { label: 'Chinamax', value: 'Chinamax' },
    ],
    'Passenger ship': [],
  };
  selectedTypeOfShip: any;
  selectedSegment: string = 'MR';
  selectedCondition: any = 'Ballast';
  selectedClient: any;
  selectedSpeed: any = ['11', '12'];
  originalApiResponse: any[] = [];
  isConsumptionAsc: boolean = true;
  isAlphaAsc: boolean = true;
  username: any;
  private destroy$ = new Subject<void>();
  subusername: any;
  isLoadingChart: boolean = false;
  constructor(
    private sharedDataService: DashboardService,
    private toastr: ToastrService,
    private requestFormService: RequestFormService,
  ) {}

  ngOnInit() {
    this.selectedTypeOfShip = 'Tanker';
    this.onTypeOfShipChange();
    this.selectedSegment = 'LR3/Suezmax';
    this.username = localStorage.getItem('username') ?? '';
    this.subusername = localStorage.getItem('loginPic');
    if (this.username !== 'Eiger Shipping') {
      this.loadChartData();
    }
    this.requestFormService.themeChanged
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.prepareChart(this.originalApiResponse);
      });
  }
  get selectedSpeedLabels(): string {
    return this.selectedSpeed.join(', ');
  }
  toggleSpeedDropdown() {
    this.speedDropdownOpen = !this.speedDropdownOpen;
  }
  private isDemoUser(): boolean {
    return this.subusername?.toLowerCase() === 'demo';
  }
  private getMaskedVesselName(item: any): string {
    const vesselName = String(item?.vessel_name || '').trim();

    if (vesselName === 'Llevant') {
      return 'Vessel 1';
    }

    if (vesselName === 'Migjorn') {
      return 'Vessel 2';
    }

    return vesselName || 'NA';
  }

  onSpeedCheckboxChange(event: Event, speed: string) {
    const checkbox = event.target as HTMLInputElement;
    if (checkbox.checked) {
      if (this.selectedSpeed.length < 2) {
        this.selectedSpeed.push(speed);
        this.loadChartData();
      } else {
        checkbox.checked = false;
        this.toastr.warning('You can select a maximum of 2 speeds.');
      }
    } else {
      this.selectedSpeed = this.selectedSpeed.filter(
        (s: string) => s !== speed,
      );
      this.loadChartData();
    }
  }
  onTypeOfShipChange() {
    this.segmentOptions = this.segmentMapping[this.selectedTypeOfShip] || [];
    this.selectedSegment = ''; // reset selected segment
  }

  onSpeedChange() {
    if (this.selectedSpeed.length > 2) {
      this.selectedSpeed.pop();
      alert('You can select a maximum of 2 speeds only.');
      return;
    }
    this.loadChartData();
  }

  loadChartData() {
    if (
      !this.selectedSegment ||
      !this.selectedCondition ||
      this.selectedSpeed.length === 0
    )
      return;

    const payload = {
      segment: this.selectedSegment,
      condition: this.selectedCondition,
      speed: this.selectedSpeed,
    };
this.isLoadingChart = true;
    this.sharedDataService.getTcpData(payload).subscribe({
      next: (data: any) => {
        if (this.isDemoUser()) {
          data = (data || [])
            .filter((item: any) => {
              const vesselName = String(item?.vessel_name || '').trim();

              return vesselName === 'Llevant' || vesselName === 'Migjorn';
            })
            .map((item: any) => ({
              ...item,
              vessel_name: this.getMaskedVesselName(item),
            }));
        }
        const clientFilters: { [key: string]: (item: any) => boolean } = {
          'Eiger Shipping': (item) => item.client === 'EMZ OIL',
          'Zeronorth ZN': (item) => item.client === 'ZeroNorth',
          'Elite Shipping': (item) =>
            item.client_name === 'Elite' ||
            item.client_name === 'ELITE TANKSHIP DMCC',
          'Bunge Shipping': (item) => item.client === 'Bunge',
          'Alcor Shipping': (item) => item.client === 'ALCOR CHARTERING DMCC',
          'EMZoil Shipping': (item) => {
            const c = (item.client_name ?? item.client ?? '').toLowerCase();
            return c === 'emz oil' || c === 'emzoil fzco' || c.includes('emz');
          },
          'Ethiopian Shipping & Logistics': (item) =>
            item.client_name.toLowerCase() === 'ethiopian shipping & logistics',
        };
        if (this.username === 'Meraki - Operations') {
          data = data;
        } else if (clientFilters[this.username]) {
          data = data.filter(clientFilters[this.username]);
        }

        this.originalApiResponse = data;
        this.clientOptions = [
          ...new Set(
            data.map((item: { client: any }) => item.client).filter(Boolean),
          ),
        ];
        this.prepareChart(data);
        this.isLoadingChart = false;
      },
      error: (err) => {
        this.toastr.info(err.error.error);
        this.isLoadingChart = false;
      },
    });
  }

  prepareChart(apiResponse: any[]) {
    if (!apiResponse || apiResponse.length === 0) {
      this.chartOptions = new Chart({
        title: { text: 'No data available' },
      });
      return;
    }

    // 🔹 FILTER BY CLIENT
    let filteredResponse = apiResponse;
    if (this.selectedClient) {
      filteredResponse = apiResponse.filter(
        (d: any) => d.client === this.selectedClient,
      );
    }

    // 🔹 UNIQUE VESSELS
    const allVessels: string[] = [
      ...new Set(filteredResponse.map((d: any) => d.vessel_name)),
    ];

    // 🔹 KEEP VESSELS WITH AT LEAST ONE SPEED > 0
    const filteredVessels: string[] = allVessels.filter((vessel) => {
      const vesselData = filteredResponse.find(
        (d: any) => d.vessel_name === vessel,
      );

      return this.selectedSpeed.some((spd: string) => {
        const val = vesselData?.speed?.[spd];
        return val && parseFloat(val) > 0;
      });
    });

    const seriesList: Highcharts.SeriesOptionsType[] = [];
    const avgLines: Highcharts.YAxisPlotLinesOptions[] = [];
    const averagePerSpeed: any = {};

    // 🔹 LOOP THROUGH SPEEDS
    this.selectedSpeed.forEach((spd: string) => {
      const speedConsumptions: number[] = [];

      const data: number[] = filteredVessels.map((vessel) => {
        const vesselData = filteredResponse.find(
          (d: any) => d.vessel_name === vessel,
        );

        const val = vesselData?.speed?.[spd];

        if (val !== null && val !== undefined && val !== '') {
          const num = parseFloat(val);
          speedConsumptions.push(num);
          return num;
        }

        return 0; // only for chart display
      });

      // Average excluding missing values
      const avg =
        speedConsumptions.length > 0
          ? Number(
              (
                speedConsumptions.reduce((sum, value) => sum + value, 0) /
                speedConsumptions.length
              ).toFixed(2),
            )
          : 0;

      averagePerSpeed[spd] = avg;

      // 🔹 AVG LINE
      const avgLineColors = ['#e21616ff', '#e08105ff'];
      const colorIndex = avgLines.length % avgLineColors.length;

      avgLines.push({
        color: avgLineColors[colorIndex],
        value: avg,
        width: 2,
        dashStyle: 'Dash',
        zIndex: 5,
        label: {
          text: `Avg (${spd}): ${avg} MT`,
          align: 'right',
          style: {
            color: avgLineColors[colorIndex],
            fontFamily: 'Poppins, sans-serif',
          },
        },
      });

      // 🔹 SERIES
      seriesList.push({
        name: `Speed ${spd}`,
        type: 'column',
        data,
        color: this.getColorForSpeed(spd),
      });
    });

    // 🔹 BUILD CHART
    this.chartOptions = this.buildStyledChart(
      filteredVessels,
      seriesList,
      avgLines,
      averagePerSpeed,
    );
  }

  buildStyledChart(
    vesselNames: any[],
    seriesList: Highcharts.SeriesOptionsType[],
    avgLines: any[],
    averagePerSpeed: any,
  ): Chart {
    const labelColor = this.isDarkMode() ? '#f5f5f5' : '#0088B5';
    return new Chart({
      chart: {
        type: 'column',
        backgroundColor: 'transparent',
        borderRadius: 10,
        style: { fontFamily: 'Inter, system-ui, sans-serif' },
      },

      title: {
        text: `TCP Graph (${this.selectedCondition} - ${this.selectedSegment})`,
        style: {
          fontFamily: 'Inter, system-ui, sans-serif',
          color: labelColor,
          fontSize: '15px',
          fontWeight: '600',
        },
      },

      xAxis: {
        categories: vesselNames,
        lineColor: '#334155',
        tickColor: '#334155',
        title: {
          text: 'Vessel Names',
          style: {
            fontFamily: 'Inter, system-ui, sans-serif',
            color: labelColor,
            fontSize: '12px',
          },
        },
        labels: {
          rotation: -45,
          style: {
            fontSize: '11px',
            fontFamily: 'Inter, system-ui, sans-serif',
            color: labelColor,
          },
          useHTML: true,
          formatter: function () {
            const name = this.value as string;
            return `<span title="${name}">${name.length > 12 ? name.slice(0, 10) + '…' : name}</span>`;
          },
        },
      },

      yAxis: {
        min: 0,
        title: {
          text: 'Consumption (MT)',
          style: {
            fontFamily: 'Inter, system-ui, sans-serif',
            color: labelColor,
            fontSize: '12px',
          },
        },
        labels: {
          style: {
            fontFamily: 'Inter, system-ui, sans-serif',
            color: labelColor,
          },
        },
        plotLines: avgLines,
      },
      plotOptions: {
        column: {
          dataLabels: {
            enabled: true,
            color: labelColor,
            style: {
              fontFamily: 'Poppins, sans-serif',
              textOutline: 'none',
              fontSize: '12px',
            },
          },
        },
      },

      legend: {
        itemStyle: { color: labelColor },
      },

      tooltip: {
        shared: false,
        formatter: function () {
          const speed = this.series.name.replace('Speed ', '');
          const avg = averagePerSpeed[speed];

          return `
          <b>${this.x}</b><br>
          <span style="color:${this.color}">\u25CF</span>
          Consumption: <b>${this.y} MT</b><br>
          <span style="color:${this.color}">\u25CF</span>
          Average (Speed ${speed}): <b>${avg} MT</b><br>
        `;
        },
      },

      credits: { enabled: false },

      series: seriesList,
    });
  }

  // Simple helper to give different colors per speed
  getColorForSpeed(speed: string): string {
    const colors: { [key: string]: string } = {
      '11.5': '#3a75afff',
      '12.5': '#0074D9',
      '13': '#104177',
      '13.5': '#28596c',
      '11': '#c17e44ff',
      '12': '#4294dcff',
    };
    return colors[speed] || '#104177';
  }
  sortByConsumptionChart() {
    if (!this.originalApiResponse || this.originalApiResponse.length === 0)
      return;

    // Sort by total consumption of the first selected speed
    const speed = this.selectedSpeed[0];
    const sortedData = [...this.originalApiResponse].sort((a, b) => {
      const aVal = parseFloat(a.speed?.[speed]) || 0;
      const bVal = parseFloat(b.speed?.[speed]) || 0;
      return this.isConsumptionAsc ? aVal - bVal : bVal - aVal;
    });

    this.isConsumptionAsc = !this.isConsumptionAsc; // toggle for next click
    this.prepareChart(sortedData);
  }

  azSortChart() {
    if (!this.originalApiResponse || this.originalApiResponse.length === 0)
      return;

    const sortedData = [...this.originalApiResponse].sort((a, b) => {
      const nameA = a.vessel_name.toLowerCase();
      const nameB = b.vessel_name.toLowerCase();
      if (nameA < nameB) return this.isAlphaAsc ? -1 : 1;
      if (nameA > nameB) return this.isAlphaAsc ? 1 : -1;
      return 0;
    });

    this.isAlphaAsc = !this.isAlphaAsc; // toggle for next click
    this.prepareChart(sortedData);
  }
  clearSelections() {
    this.selectedTypeOfShip = 'Tanker';
    this.onTypeOfShipChange();
    this.selectedSegment = 'MR';
    this.selectedSpeed = ['11', '12'];
    this.selectedClient = null;
    this.loadChartData();
  }
  isDarkMode() {
    return this.requestFormService.isDarkMode();
  }
}
